import React, { useEffect, useState } from 'react';
import axios from 'axios';
import API_BASE_URL from '../config';

const Administration = () => {
  const [users, setUsers] = useState([]);
  const [questions, setQuestions] = useState([]);
  const [error, setError] = useState('');

  // Fonction pour télécharger un fichier JSON
  const downloadJson = (filename, data) => {
    const blob = new Blob([JSON.stringify(data, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem('token');

        // Récupérer les utilisateurs
        const usersResponse = await axios.get(`${API_BASE_URL}/api/admin/users`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUsers(usersResponse.data);

        // Récupérer les questions
        const questionsResponse = await axios.get(`${API_BASE_URL}/api/questions`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setQuestions(questionsResponse.data);
      } catch (err) {
        console.error('Erreur lors de la récupération des données :', err.message);
        setError('Erreur lors de la récupération des données. Veuillez réessayer.');
      }
    };

    fetchData();
  }, []);

  if (error) {
    return <p style={{ color: 'red', textAlign: 'center' }}>{error}</p>;
  }

  return (
    <div style={{ textAlign: 'center', marginTop: '50px' }}>
      <h1>Administration</h1>

      <div style={{ margin: '20px 0' }}>
        <h2>Utilisateurs</h2>
        <button onClick={() => downloadJson('users.json', users)}>Télécharger Utilisateurs</button>
      </div>

      <div style={{ margin: '20px 0' }}>
        <h2>Questions</h2>
        <button onClick={() => downloadJson('questions.json', questions)}>Télécharger Questions</button>
      </div>

      <div style={{ marginTop: '40px' }}>
        <h3>Données Utilisateurs</h3>
        <pre style={{ textAlign: 'left', maxHeight: '300px', overflow: 'auto' }}>
          {JSON.stringify(users, null, 2)}
        </pre>
      </div>

      <div style={{ marginTop: '40px' }}>
        <h3>Données Questions</h3>
        <pre style={{ textAlign: 'left', maxHeight: '300px', overflow: 'auto' }}>
          {JSON.stringify(questions, null, 2)}
        </pre>
      </div>
    </div>
  );
};

export default Administration;
